"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function base64urlEncode(arg) {
    const step1 = window.btoa(arg);
    const step2 = step1.split("=")[0];
    const step3 = step2.replace(/\+/g, "-");
    const step4 = step3.replace(/\//g, "_");
    return step4;
}
exports.base64urlEncode = base64urlEncode;
function base64urlDecode(s) {
    const step1 = s.replace(/-/g, "+");
    const step2 = step1.replace(/_/g, "/");
    let step3 = step2;
    switch (step2.length % 4) {
        case 0:
            break;
        case 2:
            step3 += "==";
            break;
        case 3:
            step3 += "=";
            break;
        default:
            throw new Error("Illegal base64url string!");
    }
    return window.atob(step3);
}
exports.base64urlDecode = base64urlDecode;
//# sourceMappingURL=base64url.js.map